module.exports = __webpack_public_path__ + "static/media/start-screen-personal-finance.7798d41e.png";